import {BrowserModule} from '@angular/platform-browser';
import {APP_INITIALIZER, NgModule} from '@angular/core';

import {AppComponent} from './app.component';
import {StepperComponent} from './components/stepper/stepper.component';
import {StepsService} from "./services/steps.service";
import {Step1Component} from './components/step1/step1.component';
import {Step2Component} from './components/step2/step2.component';
import {Step3Component} from './components/step3/step3.component';
import {TranslateModule} from "@ngx-translate/core";
import {ResellersService} from "./services/resellers.service";
import {HttpClientModule} from "@angular/common/http";
import {ResellerComponent} from './components/reseller/reseller.component';
import {UserService} from "./services/user.service";
import {AgmCoreModule} from "@agm/core";
import {AgmMarkerClustererModule} from "@agm/markerclusterer";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {environment} from "../environments/environment";
import {CountriesService} from "./services/countries.service";
import {NgxPopperjsModule} from 'ngx-popperjs';
import {ChoiceService} from "./services/choice.service";
import { ShareholdersFormComponent } from './components/shareholders-form/shareholders-form.component';
import { OnlyNumbers} from "./directives/OnlyNumbers.directive";

@NgModule({
    declarations: [
        AppComponent,
        StepperComponent,
        Step1Component,
        Step2Component,
        Step3Component,
        ResellerComponent,
        ShareholdersFormComponent,
        OnlyNumbers
    ],
    imports: [
        BrowserModule,
        HttpClientModule,
        TranslateModule.forRoot(),
        AgmCoreModule.forRoot({
            apiKey: environment.mapKay
        }),
        AgmMarkerClustererModule,
        FormsModule,
        ReactiveFormsModule,
        NgxPopperjsModule
    ],
    providers: [StepsService,
        {
            provide: APP_INITIALIZER,
            useFactory: (ResellersService) => () => null,
            deps: [ResellersService],
            multi: true
        },
        {
            provide: APP_INITIALIZER,
            useFactory: (UserService) => () => null,
            deps: [UserService],
            multi: true
        },
        {
            provide: APP_INITIALIZER,
            useFactory: (CountriesService) => () => null,
            deps: [CountriesService],
            multi: true
        },
        {
            provide: APP_INITIALIZER,
            useFactory: (ChoiceService) => () => null,
            deps: [ChoiceService],
            multi: true
        }


    ],
    bootstrap: [AppComponent],
})
export class AppModule {
}
